import {Component, OnDestroy, OnInit} from '@angular/core';
import {BaseComponent} from 'compob2b-libs';
import {fromEvent, Subscription} from 'rxjs';

@Component({
    selector: 'app-state-topline',
    templateUrl: './app-state-topline.component.html',
    standalone: false
})
export class AppStateToplineComponent extends BaseComponent implements OnInit, OnDestroy {

  protected readonly window = window;
  networkError: boolean = false;
  networkStatus$: Subscription = Subscription.EMPTY;

  ngOnInit(): void {
    this.checkNetworkStatus();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.networkStatus$.unsubscribe();
  }

  checkNetworkStatus() {
    this.networkStatus$ = fromEvent(window, 'offline').subscribe(_ => {

      const headers = new Headers();
      headers.append('cache-control', 'no-cache');
      headers.append('pragma', 'no-cache');
      this.compoApiService.head(window.location.origin)
        .subscribe(() => {
        }, error => {
          console.error(error);

          this.networkError = true;
          console.error('checkNetworkStatus', this.networkError, navigator.onLine);
          this.cdr.detectChanges();
        });
    });
  }

  reload() {
    window.location.reload();
  }
}
